import { atom } from 'jotai';
import { AssistantAttentionReason } from '../../schemas/agent-conversation.schema';

export interface AssistantAttention {
  readonly conversationId: number;
  readonly reason: AssistantAttentionReason;
  readonly title: string | null;
}

/** What the badge and the toast say for each reason. */
export const ATTENTION_MESSAGE: Readonly<Record<AssistantAttentionReason, string>> = {
  [AssistantAttentionReason.needsInput]: 'Atlas needs your input',
  [AssistantAttentionReason.update]: 'Atlas has an update',
};

/**
 * An Atlas conversation that needs the user while the panel is closed or shows another one;
 * cleared once the panel shows it.
 */
export const assistantAttentionAtom = atom<AssistantAttention | null>(null);

/**
 * True while the app holds the assistant socket open for the whole session (Customer Success
 * users): the panel then neither connects nor disconnects it.
 */
export const assistantSocketHeldAtom = atom(false);
